import { Component, Output, EventEmitter, Input, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LosStateService } from '../los-state.service';
import { LoanApplicationItem } from '../../loan-applications/loan-applications.interface';

@Component({
  selector: 'app-e-mandate',
  templateUrl: './e-mandate.component.html',
  styleUrls: ['./e-mandate.component.css']
})
export class EMandateComponent implements OnInit {
  @Input() applicationId: number | null = null;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  private losState = inject(LosStateService);
  private destroyRef = inject(DestroyRef);

  applicationData: LoanApplicationItem | null = null;

  mandateType = 'enach';
  emiDate = '20th of every month';
  mandateStatus = 'Pending registration';
  mandateActive = false;
  mandateFailed = false;

  ngOnInit(): void {
    this.losState.applicationData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(app => this.applicationData = app);
  }

  registerMandate(): void { 
    // Logic to trigger NPCI NACH registration would go here
  }

  simulateNpci(): void {
    this.mandateStatus = 'Active — NPCI confirmed';
    this.mandateActive = true;
  }
}
